import { DEFAULT_LOCALE } from './utils';

let dateFormatLocale = DEFAULT_LOCALE;

export const dateFormatStore = {
  get: () => dateFormatLocale,
  set: (locale: string) => {
    dateFormatLocale = locale;
  },
};
